import { makeStyles } from '@material-ui/core';
import { getFillColor, LogoProps } from './common';

export const LogoIcon = ({ applyTheme = false }: LogoProps) => {
  const classes = makeStyles(theme => ({
    svg: {
      width: 'auto',
      height: 24,
    },
    path: {
      fill: getFillColor(theme, applyTheme),
    },
  }))();

  return (
    <>
      <svg
        className={classes.svg}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 26"
      >
        <path
          className={classes.path}
          d="M5.55692 26.087H0L12.8935 0H18.4867L5.55692 26.087ZM30 26.087H24.2978L18.9952 15.354L21.7918 9.61491L30 26.087Z"
        />
      </svg>
    </>
  );
};
